import { IDraggableSidebarItemResolved } from "../../controls";
import { ArsSidebarItemVariable } from "./interface";

export interface VariableSidebarItemProps {
  item: IDraggableSidebarItemResolved<ArsSidebarItemVariable>;
  selected?: boolean;
}

/**
 * Custom sidebar item renderer for variables.
 *
 * @param props - Props containing the sidebar item and its selected state
 * @param props.item - Sidebar item
 * @param props.selected - Whether item is selected
 * @returns Variable display element
 */
export const VariableSidebarItem = ({
  item,
  selected,
}: VariableSidebarItemProps): React.ReactElement => (
  <div
    className={`px-2 py-1 border rounded w-100 ${selected ? "border-primary bg-primary-subtle" : ""}`}
    style={{ cursor: "grab" }}
  >
    <div className="fw-semibold">{item.label}</div>
    <small className="text-muted">
      {item.data.dropItem.name} {item.data.dropItem.dataType}
    </small>
  </div>
);

VariableSidebarItem.displayName = "VariableSidebarItem";
